module.exports = __webpack_public_path__ + "static/media/rugby_icon.714d27e3.svg";